import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    try {
      return localStorage.getItem('top3_sidebar_collapsed') === '1';
    } catch (error) {
      return false;
    }
  });

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('top3_sidebar_collapsed', next ? '1' : '0');
      } catch (error) {
        // no-op
      }
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex pt-16">
        {!isAdminRoute && (
          <Sidebar
            collapsed={isSidebarCollapsed}
            onToggleCollapse={handleToggleSidebar}
          />
        )}
        <main className={`flex-1 p-6 ${isAdminRoute ? '' : (isSidebarCollapsed ? 'md:ml-20' : 'md:ml-64')}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
